import OpenSeadragon from 'openseadragon';

export type OSDHandle = {
  viewer: OpenSeadragon.Viewer;
  getItem: () => OpenSeadragon.TiledImage | null;
  destroy: () => void;
};

const TILE_SOURCE_URL = '/tiles/map.dzi';

export default function createViewer(container: HTMLElement): OSDHandle {
  const viewer = OpenSeadragon({
    element: container,
    prefixUrl: 'https://cdn.jsdelivr.net/npm/openseadragon@4.1.1/build/openseadragon/images/',
    tileSources: TILE_SOURCE_URL,
    showNavigationControl: true,
    gestureSettingsMouse: { clickToZoom: true, dblClickToZoom: true },
    immediateRender: true,
    maxZoomPixelRatio: 3,
    visibilityRatio: 1.0,
    blendTime: 0.1,
    animationTime: 0.9,
    imageLoaderLimit: 6,
  });

  const getItem = () => (viewer.world.getItemCount() > 0 ? viewer.world.getItemAt(0) : null);

  const destroy = () => viewer.destroy();

  viewer.addHandler('open-failed', (e) => {
    // eslint-disable-next-line no-console
    console.error('OSD open failed:', e?.message || e);
  });

  return { viewer, getItem, destroy };
}
